import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import { MessageBar, MessageBarType, Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { NotificationType } from "@stores/notifications/NotificationsStore.ts";

export const Notifications: FunctionComponent = observer(() => {
  const { notification } = useStores();
  return (
    <Stack
      styles={{
        root: { position: "absolute", right: 260, top: 8, zIndex: 1000001 }
      }}
    >
      {notification.respondNotifications.map(x => (
        <MessageBar
          key={x.key}
          messageBarType={toMessageBarType(x.type)}
          dismissButtonAriaLabel="Close"
          onDismiss={() => {
            notification.close(x.key);
          }}
          styles={x.messageBarStyles}
        >
          {x.message}
        </MessageBar>
      ))}
    </Stack>
  );
});

const toMessageBarType = (notificationType: NotificationType) => {
  switch (notificationType) {
    case "error":
      return MessageBarType.error;
    case "info":
      return MessageBarType.info;
    case "success":
      return MessageBarType.success;
    case "warning": {
      return MessageBarType.warning;
    }
  }
};
